import { Navbar, Container, Nav } from "react-bootstrap";

function NavbarVixo() {
  return (
    <Navbar expand="lg" variant="dark" bg="black" fixed="top">
      <Container>
        <Navbar.Brand href="#">VIXO</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="#services">Services</Nav.Link>
            <Nav.Link href="#portfolio">Portfolio</Nav.Link>
            <Nav.Link href="#contact">Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarVixo;
